import StarterKit from '@tiptap/starter-kit';
import Link from '@tiptap/extension-link';
import Mention from '@tiptap/extension-mention';
import { Placeholder } from '@tiptap/extensions';
import { getMentionsSetup, MentionItem } from './mention';
import styles from './RichTextInput.module.css';
import type { Extensions } from '@tiptap/core';

/**
 * Creates the standard TipTap extensions configuration used across the app
 */
export function createRichTextExtensions(options: { mentionItems?: MentionItem[]; placeholder?: string }): Extensions {
  const { mentionItems = [], placeholder } = options;

  const mentionsSetup = getMentionsSetup(mentionItems);

  const baseExtensions = [
    StarterKit.configure({
      // Enable all markdown-compatible features from StarterKit
      // Bold, Italic, Strike (strikethrough), Heading, Blockquote,
      // BulletList, OrderedList, Code, CodeBlock, HorizontalRule are all enabled by default
      link: false, // Disable the default link extension (we use the custom one below)
    }),
    Link.configure({
      HTMLAttributes: {
        class: styles.link,
      },
    }),
    Mention.configure({
      HTMLAttributes: {
        class: styles.mention,
      },
      suggestion: mentionsSetup,
    }),
    ...(placeholder
      ? [
          Placeholder.configure({
            placeholder,
          }),
        ]
      : []),
  ];
  return baseExtensions as Extensions;
}
